module.exports = __webpack_public_path__ + "assets/cbde1dd4731556df1d708342a62fd23a.svg";